import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadCompanyAsset: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/utility/file/public${params ? `?${params}` : ''}`,
    );
    return result.data;
  },
};
